import axios from "axios";

import API_BASE from "@/constants/ApiBase";

export function exportStock(ids = []) {
  return axios
    .post(`${API_BASE}/stock/export`,
      {
        ids
      })
    .then((response) => response);
}